import { createAsyncThunkActionTypes } from './action-utils';

export const fetchPartner = createAsyncThunkActionTypes('partner/fetchPartner');
